export default __webpack_public_path__ + "static/media/ic_doc_white.2ff9177a.png";